import { render, staticRenderFns } from "./CategoriesMainview.vue?vue&type=template&id=f5ce4f88&"
import script from "./CategoriesMainview.vue?vue&type=script&lang=js&"
export * from "./CategoriesMainview.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesMainview.vue?vue&type=style&index=0&id=f5ce4f88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports